import React from 'react';
import FactoryLeadTimeDisplay from './FactoryLeadTimeDisplay';
import factoryLeadIcon from "src/assets/images/factory-lead-icon.svg";
import { Tooltip } from '../Global/Tooltip';
import { useSystem } from "src/hooks/system";

const ProductInventoryDisplay = (props) => {
    const { single_product, single_product_inventory, showDashedLine = true, imageShow = true, isFromPDP = false, position = "top center" } = props;
    const [,{ get_quantity_format }] = useSystem();
    return (
        <>
            {!isFromPDP ?
                <div className='d-flex flex-column w-100'>
                    <ul className="list-text availibility-list-text mb-3">
                        {!single_product?.SoftwareDownloadFlag ? <>
                            {single_product?.isAvnetDistributor &&
                                <>
                                    <li className="text-darkgreen">
                                        <span className="d-flex text-darkgreen w-100">
                                            <b>In Stock :</b>
                                            <b className='ms-auto'>{get_quantity_format(single_product_inventory?.inventoryQty)}</b>
                                            <Tooltip
                                                opener={() => <i className="fa fa-check-circle ms-1" />}
                                                content={() => "Indicates real-time inventory"}
                                            />


                                        </span>
                                    </li>
                                    {single_product_inventory?.inventoryQty > 0 &&
                                        <>
                                            {single_product?.sapTlaTypeCd ?
                                                <>
                                                    <li><span><img className={'me-1'} src={factoryLeadIcon}></img>Ships to 2-3 weeks</span></li>
                                                    <li><span><img className={'me-1'} src={factoryLeadIcon}></img>Parts require assembly</span></li>
                                                </>
                                                :
                                                <li>
                                                    <span><img className={'me-1'} src={factoryLeadIcon}></img>Ships in 1 bus. day</span>
                                                </li>
                                            }
                                        </>
                                    }

                                    {single_product_inventory?.factoryStock > 0 &&
                                        <>
                                            {showDashedLine && <li>
                                                <div className='seprator-dashed'></div>
                                            </li>}
                                            <li className="text-black">
                                                <span className="d-flex text-black w-100">
                                                    <i className="fa fa-check-circle me-1"></i>
                                                    <b className='me-1'>{get_quantity_format(single_product_inventory?.factoryStock)}</b>
                                                    <b>- Factory Stock</b>
                                                </span>
                                            </li>
                                            <li>
                                                <span><img className={'me-1'} src={factoryLeadIcon}></img>Ships in 2-4 weeks</span>
                                            </li>
                                        </>
                                    }
                                </>
                            }
                            {single_product?.isNewarkDistributor &&
                                <>
                                    <li className="text-darkgreen">
                                        <span className="d-flex text-darkgreen w-100">
                                            <b>In Stock :</b>
                                            <b className='ms-auto'>{get_quantity_format(single_product_inventory?.inventoryQty)}</b>
                                            <Tooltip
                                                opener={() => <i className="fa fa-check-circle ms-1" />}
                                                content={() => "Indicates real-time inventory"}
                                            />
                                        </span>
                                    </li>
                                    {single_product_inventory?.inventoryQty > 0 ?
                                        <>
                                            <li><span><img className={'me-1'} src={factoryLeadIcon}></img>Domestic : Ships in 1-2 bus. days</span></li>
                                            <li><span><img className={'me-1'} src={factoryLeadIcon}></img>Int'l: Ships in 10 bus. days</span></li>
                                            <li> <span><img className={'me-1'} src={factoryLeadIcon}></img>Fulfilled by Newark</span></li>
                                        </>
                                        :
                                        <li>
                                            <span><img className={'me-1'} src={factoryLeadIcon}></img>Fulfilled by Newark</span>
                                        </li>
                                    }
                                </>
                            }
                            {single_product?.isPartnerDistributor &&
                                <>
                                    <li className="text-black">
                                        <span className="d-flex text-black w-100">
                                            <b className='me-1'>{single_product_inventory?.factoryStock}</b>
                                            <b>- Partner Stock</b>
                                        </span>
                                    </li>
                                    {single_product_inventory?.factoryStock > 0 ?
                                        <>
                                            <li><span><img className={'me-1'} src={factoryLeadIcon}></img>Ships in 2-4 weeks</span></li>
                                            <li><span><img className={'me-1'} src={factoryLeadIcon}></img>Fulfilled by Avnet partner</span></li>
                                        </>
                                        :
                                        <li>
                                            <span><img className={'me-1'} src={factoryLeadIcon}></img>Fulfilled by Avnet Partner.</span>
                                        </li>
                                    }
                                </>
                            }
                        </>
                            :

                            <>
                                <li className="text-darkgreen">
                                    <span className="d-flex text-darkgreen w-100">
                                        <b>In Stock downloadable</b>
                                    </span>
                                </li>

                            </>

                        }
                        {!single_product?.isPartnerDistributor && <>
                            {showDashedLine && <li>
                                <div className='seprator-dashed'></div>
                            </li>}
                            <li>
                                <div className='d-flex align-items-center w-100'>
                                    <FactoryLeadTimeDisplay
                                        single_product={single_product}
                                        single_product_inventory={single_product_inventory}
                                        imageShow={imageShow}
                                        position={position} />
                                </div>
                            </li>
                        </>}

                    </ul>
                </div>
                :
                <>
                    {!single_product?.SoftwareDownloadFlag ?
                        <>
                            {single_product?.isAvnetDistributor &&
                                <>
                                    <div>
                                        <div className="me-1 text-darkgreen stock-price-title-text">
                                            In Stock : {get_quantity_format(single_product_inventory?.inventoryQty)} <i className="fa fa-check-circle" />
                                        </div>
                                        {single_product_inventory?.inventoryQty > 0 &&
                                            <>
                                                {single_product?.sapTlaTypeCd ?
                                                    <>
                                                        <div><img className={'me-1'} src={factoryLeadIcon}></img>Ships to 2-3 weeks</div>
                                                        <div><img className={'me-1'} src={factoryLeadIcon}></img>Parts require assembly</div>
                                                    </> :
                                                    <div><img className={'me-1'} src={factoryLeadIcon}></img>Ships in 1 bus. day</div>}
                                            </>
                                        }
                                        {single_product_inventory?.factoryStock > 0 &&
                                            <>
                                                <div className='mt-1'></div>

                                                <span className="d-flex text-black w-100">
                                                    <i className="fa fa-check-circle me-1"></i>
                                                    <b className='me-1'>{get_quantity_format(single_product_inventory?.factoryStock)}</b>
                                                    <b>- Factory Stock</b>
                                                </span>

                                                <span><img className={'me-1'} src={factoryLeadIcon}></img>Ships in 2-4 weeks</span>
                                            </>
                                        }
                                    </div>
                                </>
                            }
                            {single_product?.isNewarkDistributor &&
                                <>
                                    <div>
                                        <div className="me-1 text-darkgreen stock-price-title-text">
                                            In Stock : {get_quantity_format(single_product_inventory?.inventoryQty)} <i className="fa fa-check-circle" />
                                        </div>
                                        {single_product_inventory?.inventoryQty > 0 ?
                                            <>
                                                <div><img className={'me-1'} src={factoryLeadIcon}></img>Domestic : Ships in 1-2 bus. days</div>
                                                <div><img className={'me-1'} src={factoryLeadIcon}></img>Int'l: Ships in 10 bus. days</div>
                                                <div><img className={'me-1'} src={factoryLeadIcon}></img>Fulfilled by Newark</div>
                                            </>
                                            :
                                            <div><img className={'me-1'} src={factoryLeadIcon}></img>Fulfilled by Newark</div>

                                        }
                                    </div>
                                </>
                            }
                            {single_product?.isPartnerDistributor &&
                                <>
                                    <div>
                                        <div className="me-1 text-black stock-price-title-text">&nbsp;<i className="fa fa-check-circle" />&nbsp;
                                            {single_product_inventory?.factoryStock} - Partner Stock
                                        </div>
                                        {single_product_inventory?.factoryStock > 0 ?
                                            <>
                                                <div><img className={'me-1'} src={factoryLeadIcon}></img>Ships in 2-4 weeks</div>
                                                <div><img className={'me-1'} src={factoryLeadIcon}></img>Fulfilled by Avnet partner</div>
                                            </>
                                            :
                                            <div><img className={'me-1'} src={factoryLeadIcon}></img>Fulfilled by Avnet Partner.</div>
                                        }
                                    </div>
                                </>
                            }
                        </>:<>
                            <div>
                                <div className="me-1 text-darkgreen stock-price-title-text">
                                    In Stock downloadable
                                </div>
                            </div>
                        </>}
                </>}
        </>
    )
}

export default ProductInventoryDisplay;